export default __webpack_public_path__ + "static/media/pop_background.2a5dc6e9.png";